const {minArrayLength} = require("@common/react/cs-form/validators/min-length-array");
const {textFilter} = require("../../../../../../common/filters/filter-form-config/text-filter-config");
const {numericFilter} = require("../../../../../../common/filters/filter-form-config/numeric-filter-config");
const {dateFilter} = require("../../../../../../common/filters/filter-form-config/date-filter-config");

const {required} = require("@common/react/cs-form/validators/required");

const localFilterFormConfig = {
    fields: {
        label: {
            debounce: true,
        },
        ...dateFilter(),
        ...numericFilter(),
        ...textFilter(),
        ...[
            {
                path: ["columns"],
                validators: [minArrayLength(1)],
            },
        ],
    },
};
exports.localFilterFormConfig = localFilterFormConfig;
